module.exports = __webpack_public_path__ + "static/img/tooltip.47d4263.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/tooltip.jpg
// module id = lkab
// module chunks = 1